import { computed, inject } from 'vue'
import { allowedPageSize, listPageSizeStoreKey, standardPageSizes } from './pageSizeStore'
import type { ListPagerChange, ListPagerProps } from './types'

export function useListPager(props: ListPagerProps, change: (value: ListPagerChange) => void) {
  const store = inject(listPageSizeStoreKey, undefined)
  const sizes = computed(() => props.sizeOptions ?? standardPageSizes)
  const size = computed(() => props.pageSize ?? allowedPageSize(store?.read(), sizes.value, sizes.value[0] ?? 25))
  const totalPages = computed(() => Math.max(1, Math.ceil(props.totalCount / size.value)))
  const pages = computed(() => Math.max(1, Math.min(props.maxPage ?? Infinity, totalPages.value)))
  const outOfRange = computed(() => props.page > pages.value)
  const current = computed(() => Math.max(1, Math.min(props.page, pages.value)))
  const from = computed(() => (current.value - 1) * size.value + 1)
  const to = computed(() => Math.min(props.totalCount, current.value * size.value))
  const visible = computed(() => props.totalCount > 0 && !outOfRange.value)
  function go(page: number) {
    if (page < 1 || page > pages.value || page === props.page) return
    change({ page, pageSize: size.value })
  }
  function resize(pageSize: number) {
    if (!sizes.value.includes(pageSize) || pageSize === size.value) return
    store?.write(pageSize)
    change({ page: 1, pageSize })
  }
  return { sizes, size, pages, totalPages, outOfRange, current, from, to, visible, go, resize }
}
